export enum AlertType {
    Notification = 1
}